import { Draggable } from "react-beautiful-dnd";

const ItemDraggable = ({ item, itemId, deleteItem }) => {
  return (
    <Draggable draggableId={item.id} index={itemId}>
      {(provided, snapshot) => (
        <div
          ref={provided.innerRef}
          {...provided.draggableProps}
          {...provided.dragHandleProps}
          style={getItemStyle(
            snapshot.isDragging,
            provided.draggableProps.style,
          )}
        >
          {item.content}
        </div>
      )}
    </Draggable>
  );
};

const getItemStyle = (isDragging, draggableStyle) => ({
  marginBottom: "10px",
  background: isDragging ? "lightgreen" : "",
  ...draggableStyle,
});

export default ItemDraggable;
